<script>
    import StepsProgressBar from '../common/sidebar/StepsProgressBar.svelte'
    import AppComponent from '../common/AppComponent.svelte'
    import HomePage from './HomePage.svelte'
</script>

<StepsProgressBar currentPage={0}/>
<AppComponent nextPage="#/registration">
    <HomePage/>
</AppComponent>
